import React from 'react';
import { useEffect,useState } from 'react';
import logo from './logo.svg';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { NavBar } from "./components/NavBar";
import { Banner } from "./components/Banner";
import { Skills } from "./components/Skills";
import { Projects } from "./components/Projects";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import {Servecises} from "./components/Servecises"
import { PacmanLoader} from 'react-spinners';
import {Loader} from "./components/loader/Loader"
import Projectdescription from './components/project description/Projectdescription';
import { useContext } from 'react';
import { ShowContext } from './context/showContext';

import Confetti from 'react-confetti';
import MyComponent from './components/celebrationalert/celebrationalert';


function App() {
  const [loading,setloading] = useState(false)
  const [loadinghome,setloadinghome] = useState(false)
  const [convit, setconvitity] = useState(false);
  const { Isshow,desProject } = useContext(ShowContext);

  useEffect (()=>{
    setloading(true)
    setTimeout(()=>{
      setloading(false)
    },2000)
      setconvitity(true)
      setTimeout(()=>{setconvitity(false)},10000)
  },[])

  return (
      <div className="App" >

 {Isshow ? <Projectdescription  /> :""}
      {
        loading ?
      <Loader  /> 
      :
      <div style={{opacity:Isshow ? 0.5 :  1, }}> 
      {
        convit ? <Confetti numberOfPieces={200} /> :''
      }
      {Isshow ? '' :<NavBar />}
      <Banner />
      <Skills />
      <Projects />
      <Contact />
      <Footer />
      </div>

      }
    </div>
  );
}

export default App;
